import React from "react";
import '../../../styles/components/Stats.css';


const statsData = [
  { label: "COMPLETED PROJECTS", value: "750+" },
  { label: "ONGOING PROJECTS", value: "20+" },
  { label: "RETURNING CLIENTS", value: "95%" },
  { label: "CUSTOMER SUPPORT", value: "24/7" },
];

const Stats = () => {
  return (
    <section id="stats" className="stats">
      <div className="stats-container">
        <div className="stats-data">
          {statsData.map((stat, index) => (
            <div key={index} className="stat-item">
              <h3>{stat.value}</h3>
              <h3>{stat.label}</h3>
            </div>
          ))}
        </div>
        <div className="image-container">
          <img src="/images/stats/statsimg.png" alt="Logo" className="stats-logo" />
        </div>
      </div>
    </section>
  );
};

export default Stats;
